import { useQuery } from 'react-query'
import React, { Component } from "react";
import styled from "styled-components";
import { fetchPaidExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

async function fetch() {
    const { data } = await fetchPaidExplorer('byLabs')
    return data.result;
}
function PaidByLabs() {
    const { data, error, isError, isLoading } = useQuery('paidByLabs', fetch)
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer  {...dataProps } />
}
export default PaidByLabs